import { PencilLineIcon } from 'lucide-react'
import { ReactNode } from 'react'

type Props = {
    icon: ReactNode;
    label: string;
}


const ProjectDetailHeader = (props: Props) => {
    const handleEditBtnClick = () => {

    }

  return (
    <div className="flex gap-2 justify-between items-center">
       <div className="flex gap-2 items-center">
            {props.icon}
            <span>{props.label}</span>
        </div> 
        <button onClick={handleEditBtnClick}>
            <PencilLineIcon className='w-5 h-5 mr-2 text-rajapiBlue'/>
        </button>

    </div>
  )
}

export default ProjectDetailHeader